export const SESSION_KEY = 'FASTED_SESSION';
export const LOCAL_STORAGE_KEY = 'FASTED_USER';

export const getUserFromSession = () => {
  const sessionString = window.sessionStorage.getItem(SESSION_KEY) || window.localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!sessionString) return null;

  let user = null;
  try {
    user = JSON.parse(sessionString).user;
  } catch {
    // Ignore Errors
  }

  return user;
};
